import { Step } from 'react-joyride';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TourGuide } from '../../../../components';

interface ITourStep extends Step {
  skipStep?: boolean
}

type TRegisterTour = {
  runTour: boolean
  handleFinishTour: () => void
};

const RegisterTour: FC<TRegisterTour> = ({ runTour, handleFinishTour }) => {
  const { t } = useTranslation('tour');

  const tourSteps: Array<ITourStep> = [
    {
      target: '#language',
      disableBeacon: true,
      content: t('languageIcon'),
    },
    {
      target: '#register-full-name',
      disableBeacon: true,
      content: t('enterYourFullNameHere'),
    },
    {
      target: '#email-field',
      disableBeacon: true,
      content: t('enterAUniqueAndValidEmail'),
    },
    {
      target: '#register-password',
      disableBeacon: true,
      content: t('createASecurePassword'),
    },
    {
      target: '#password-validation',
      disableBeacon: true,
      content: t('asYouTypeTo'),
    },
    {
      target: '#create-button',
      disableBeacon: true,
      content: t('clickThisButtonToCreateYourAccount'),
    },
  ];

  return (
    <TourGuide steps={tourSteps} run={runTour} onFinish={handleFinishTour} />
  );
};

export {
  RegisterTour,
};
